import React, { Component } from "react";

import { connect } from "react-redux";
import { Row, Col, Card, CardHeader, CardBody, Spinner } from "reactstrap";

//SimpleBar
import SimpleBar from "simplebar-react";
import "simplebar/src/simplebar.css";

import { Link } from "react-router-dom";

import {
	viewLoghideRightSidebar,
	GetItemTimeLine,
} from "../../store/MaterialRequest/actions";
import TimeLineCard from "./timeLineCard";
import "./TimeLineLogRightbar.scss";
class TimeLineLogRightbar extends Component {
	constructor(props) {
		super(props);
		this.state = {};
		this.hideViewLogRightbar = this.hideViewLogRightbar.bind(this);
	}
	componentDidMount() {
		// this.props.GetItemTimeLine(this.props.mrItemsList[0].id);
	}

	/**
	 * Hides the right sidebar
	 */
	hideViewLogRightbar(e) {
		e.preventDefault();
		this.props.viewLoghideRightSidebar();
	}

	render() {
		return (
			<React.Fragment>
				<div className="timeLine-right-bar">
					<div className="rightbar-title px-3 py-4">
						<Link
							to="#"
							onClick={this.hideViewLogRightbar}
							className="right-bar-toggle float-right">
							<i className="mdi mdi-close noti-icon"></i>
						</Link>
						<h5 className="m-0">Time Line</h5>
					</div>
					<hr className="my-0" />

					<Row>
						{/* -------- Items List ----------  */}
						<Col md={3}>
							<div className="px-1 py-1">
								<SimpleBar style={{ height: " 90vh" }}>
									<Card body outline color="primary">
										<CardHeader className="bg-transparent border-bottom ml-0">
											<h5 className="mb-0 ">
												MR Items List (
												<span className="text-primary">
													{this.props.mrRowData.code}
												</span>
												)
											</h5>
										</CardHeader>
										<CardBody className="p-0">
											<div id="Items-menu">
												<ul
													className="metismenu list-unstyled"
													id="Items-menu">
													{this.props.mrItemsList
														.length === 0 ? (
														<>
															{this.props
																.loading && (
																<div className="text-center">
																	<Spinner color="primary" />
																</div>
															)}
														</>
													) : (
														<>
															{this.props.mrItemsList.map(
																(item, i) => (
																	<>
																		<li>
																			<Link
																				to="#"
																				onClick={() => {
																					this.props.GetItemTimeLine(
																						item.id
																					);
																				}}
																				className={
																					item.id ===
																					this
																						.props
																						.itemSelectedId
																						? "waves-effect Item-active"
																						: "waves-effect"
																				}
																				id={
																					item.code
																				}>
																				<span>
																					{
																						item
																							.product
																							.name
																					}
																				</span>
																			</Link>
																		</li>
																	</>
																)
															)}
														</>
													)}
												</ul>
											</div>
										</CardBody>
									</Card>
								</SimpleBar>
							</div>
						</Col>
						{/* -------- Time line View ----------  */}
						<Col data-simplebar md={9}>
							<Card body outline color="primary">
								<CardHeader className="bg-transparent border-bottom">
									<h5 className="mb-0">MR Item Time Line</h5>
								</CardHeader>
								<CardBody className="p-0 mb-4">
									<SimpleBar style={{ height: " 90vh" }}>
										{this.props.loading && (
											<div className="text-center mt-2">
												<span className="text-primary">
													Loading...
												</span>
											</div>
										)}
										<div className="TimeLineBody mb-4 ">
											<div class="TimeLine-box mb-4">
												<ul>
													{this.props.itemTimeLine.map(
														(item) => (
															<TimeLineCard
																item={item}
															/>
														)
													)}
													{this.props.mrIssueItem.map(
														(item) => (
															<TimeLineCard
																item={item}
															/>
														)
													)}
													{this.props.PIitemTimeLine.map(
														(item) => (
															<TimeLineCard
																item={item}
															/>
														)
													)}

													{this.props.RFQItemsTimeLine.map(
														(item) => (
															<TimeLineCard
																item={item}
															/>
														)
													)}
													{this.props.POItemsTimeLine.map(
														(item) => (
															<TimeLineCard
																item={item}
															/>
														)
													)}
													{this.props.IGPItemsTimeLine.map(
														(item) => (
															<TimeLineCard
																item={item}
															/>
														)
													)}
												</ul>
											</div>
										</div>
									</SimpleBar>
								</CardBody>
							</Card>
						</Col>
					</Row>
				</div>
				<div
					className="timeLine-right-bar-overlay"
					onClick={this.hideViewLogRightbar}>
					{" "}
				</div>
			</React.Fragment>
		);
	}
}

const mapStatetoProps = (state) => {
	const {
		Material_id,
		mrItemsList,
		mrIssueItem,
		itemTimeLine,
		itemSelectedId,
		PIitemTimeLine,
		RFQItemsTimeLine,
		POItemsTimeLine,
		IGPItemsTimeLine,

		loading,
		mrRowData,
	} = state.Materialrequest;

	return {
		Material_id,
		mrItemsList,
		mrIssueItem,
		itemTimeLine,
		itemSelectedId,
		PIitemTimeLine,
		RFQItemsTimeLine,
		POItemsTimeLine,
		IGPItemsTimeLine,

		loading,
		mrRowData,
	};
};

export default connect(mapStatetoProps, {
	viewLoghideRightSidebar,
	GetItemTimeLine,
})(TimeLineLogRightbar);
